import styled from 'styled-components';

export const Container = styled.div`
  padding: 0.8rem;
  cursor: pointer;
  position: absolute;
  z-index: 9;
  user-select: none;
  min-width: 12.5rem;
  z-index: 100;

  .categories-menu-wrapper {
    cursor: default;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: -4rem;
    margin-top: -8rem;

    height: 100vh;
    width: 100vw;
    z-index: -1;

    background: transparent;
  }

  &.show {
    background-color: var(--white);
    border-radius: 0.8rem 0.8rem 0 0;

    .categories-menu-header {
      font-weight: 700;
    }

    &.categories-children .father-categories-list,
    &.childrens-children .father-categories-list {
      border-radius: 0 0 0 0.8rem;
    }

    &.categories-children .children-categories-list {
      border-radius: 0 0 0.8rem 0;
    }

    &.childrens-children .children-categories-list {
      border-radius: 0;
    }

    .father-categories-list {
      display: flex;
      flex-direction: column;
      min-width: 12.5rem;
    }
  }

  .categories-menu-header {
    display: flex;
    align-items: center;
    font-weight: 700;
    gap: 0.8rem;
    color: var(--black);
    font-size: 1.2rem;
    user-select: none;

    .icon.x-icon {
      width: 1.6rem;
      height: 1rem;
    }
  }

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  .father-categories-list {
    z-index: 10;
    display: none;
    position: absolute;
    bottom: 1px;
    left: 0;
    width: max-content;
    transform: translateY(100%);
    background-color: var(--white);
    border-radius: 0 0 0.8rem 0.8rem;

    .fake-icon {
      width: 0.58rem;
      height: 0.81rem;
    }

    .father-category a,
    .children-category a,
    .father-category div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0.1rem 0.5rem 0.1rem 0;
    }

    .father-category .icon,
    .children-category .icon {
      margin-left: 0.4rem;
    }

    .father-category,
    .children-category {
      text-transform: none;
      padding: 0.8rem;
      color: var(--primary_color);
      min-width: 11rem;
      gap: 1.2rem;
      width: 100%;
    }

    & > *:not(:first-child):not(.children-categories-list) {
      border-top: 1px solid var(--gray_light);
    }

    .children-categories-list.brand {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      max-height: calc(11 * 2.3rem);
      width: max-content;
      max-width: 60rem;
      overflow: auto;

      ::-webkit-scrollbar-track {
        background-color: var(--white_gray);
      }

      scrollbar-track-color: var(--white_gray);
      ::-webkit-scrollbar {
        height: 0.6rem;
        background: var(--white_gray);
      }
      ::-webkit-scrollbar-thumb {
        background: var(--primary_color);
        border-radius: 1rem;
      }

      scrollbar-base-color: var(--primary_color);

      .children-category {
        width: 14rem;
        margin-right: 1rem;
      }

      .show-all-brands {
        font-weight: 700;

        button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          color: var(--blue_ocean);
          font-weight: 700;
          text-decoration: underline;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .children-categories-list,
    .children-childrens-list {
      background-color: var(--white);
      position: absolute;
      top: 0;
      left: 100%;
      width: max-content;
    }

    .children-categories-list .children-category {
      padding: 0.4rem 0.8rem;
      gap: 1.2rem;
      position: relative;
    }

    .children-childrens-list {
      border-radius: 0 0 0.8rem 0;
    }
  }
`;
